export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6976.8b987762.jpg";